import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bonusomat-board-completed is-dark" }
const _hoisted_2 = { class: "ds-modal-dialog__body" }
const _hoisted_3 = { class: "ds-modal-dialog__wrap" }
const _hoisted_4 = { class: "ds-modal-dialog__container" }
const _hoisted_5 = {
  key: 1,
  class: "ds-top-slot-headline-subheadline"
}
const _hoisted_6 = {
  key: 0,
  class: "bonusomat-board-completed__tickets"
}
const _hoisted_7 = { class: "bonusomat-board-completed__ticket" }
const _hoisted_8 = { class: "bonusomat-board-completed__ticket__text-wrapper" }
const _hoisted_9 = { class: "bonusomat-board-completed__ticket__text bonusomat-board-completed__ticket__text--prize" }
const _hoisted_10 = { class: "bonusomat-board-completed__ticket__text bonusomat-board-completed__ticket__text--number" }
const _hoisted_11 = { class: "bonusomat-board-completed__ticket__text bonusomat-board-completed__ticket__text--date" }
const _hoisted_12 = { class: "bonusomat-board-completed__ticket__text--date-mobile" }
const _hoisted_13 = { class: "bonusomat-board-completed__ticket__text--date-desktop" }
const _hoisted_14 = { class: "bonusomat-board-completed__ticket__text--small" }
const _hoisted_15 = { class: "bonusomat-board-completed__ticket__number" }
const _hoisted_16 = {
  key: 0,
  class: "bonusomat-board-completed__ticket bonusomat-board-completed__ticket--second"
}
const _hoisted_17 = {
  key: 1,
  class: "bonusomat-board-completed__ticket bonusomat-board-completed__ticket--third"
}
const _hoisted_18 = {
  key: 1,
  class: "bonusomat-board-completed__no-ticket"
}
const _hoisted_19 = { class: "bonusomat-board-completed__no-ticket__perex" }
const _hoisted_20 = {
  key: 3,
  class: "bonusomat-board-completed__no-ticket"
}

import { computed } from "vue";

import DsDivider from "@sazka/design-system/src/divider/ds-divider.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

import { bonImgUrl } from "../../utils/image-src";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";

import useBonusomatData from "../../composables/use-bonusomat-data";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-board-completed',
  setup(__props) {

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { isPlayerDataLoaded, remainingSpinsCount } = bonusomatPlayerStatus;

const { defaultDrawData, completeBoard } = useBonusomatData();

const isTicketClaimable = computed(() => remainingSpinsCount.value === 0);

const formatPrice = (price: number, separator: string) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

// HEADLINE PROPS
const wordTiket2pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "tiketů" : "tiketu"));
const wordTiket4pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "tikety" : "tiket"));
const wordTiket7pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "tikety" : "tiketem"));
const wordHe4pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "je" : "ho"));
const headlineImage = computed(() =>
    isTicketClaimable.value ? bonImgUrl("board/mr-green", "png") : bonImgUrl("board/ticket-waiting", "png")
);
const headlineImageAlt = computed(() => (isTicketClaimable.value ? "Pan Zelený" : "Tiket do Losovačky"));
const headlineHeadline = computed(() =>
    isTicketClaimable.value
        ? "Gratulujeme! Získáváte " + wordTiket4pad.value + " do Losovačky!"
        : "Už jste jen malý krůček od získání " + wordTiket2pad.value + " do Losovačky!"
);
const headlineSubheadline = computed(() =>
    isTicketClaimable.value
        ? "Splnit 48 úkolů musela být pořádná fuška, ale teď máte šanci v naší Losovačce vyhrát " +
          formatPrice(defaultDrawData.value.mainWin, "&nbsp;") +
          "&nbsp;Kč!"
        : null
);

const formattedPrize = computed(() => {
    return formatPrice(defaultDrawData.value.mainWin, ".");
});

const dateShort = computed(() => {
    return DateTimeUtils.formatDate(defaultDrawData.value.drawDate, "2-digit");
});

const date = computed(() => {
    return DateTimeUtils.formatDate(defaultDrawData.value.drawDate);
});

const time = computed(() => {
    return DateTimeUtils.formatTime(defaultDrawData.value.drawDate);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(isPlayerDataLoaded))
            ? (_openBlock(), _createBlock(DsTopSlotHeadlineSubheadline, {
                key: 0,
                headline: headlineHeadline.value,
                subheadline: headlineSubheadline.value,
                "image-src": headlineImage.value,
                "image-alt": headlineImageAlt.value
              }, null, 8, ["headline", "subheadline", "image-src", "image-alt"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "bonusomat-placeholder__skeleton bonusomat-board-completed__title-image-skeleton ds-top-slot-headline-subheadline__image" }, null, -1),
                _createElementVNode("div", { class: "bonusomat-placeholder__skeleton bonusomat-board-completed__title-skeleton" }, null, -1)
              ]))),
          _createVNode(DsDivider, { theme: "dark" }),
          (_unref(isPlayerDataLoaded))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (isTicketClaimable.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(WebpImage, {
                          src: _unref(bonImgUrl)('board/ticket-vertical', 'png'),
                          alt: "",
                          "css-class": "bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--vertical"
                        }, null, 8, ["src"]),
                        _createVNode(WebpImage, {
                          src: _unref(bonImgUrl)('board/ticket-horizontal', 'png'),
                          alt: "",
                          "css-class": "bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--horizontal"
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", null, _toDisplayString(formattedPrize.value), 1),
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bonusomat-board-completed__ticket__text--small" }, " Kč ", -1))
                          ]),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(defaultDrawData).totalTickets + 1), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(dateShort.value) + " ", 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(date.value) + " ", 1),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(time.value), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(defaultDrawData).totalTickets + 1), 1)
                      ]),
                      (_unref(defaultDrawData).ticketsToWin >= 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(WebpImage, {
                              src: _unref(bonImgUrl)('board/ticket-vertical', 'png'),
                              alt: "",
                              "css-class": "bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--vertical"
                            }, null, 8, ["src"]),
                            _createVNode(WebpImage, {
                              src: _unref(bonImgUrl)('board/ticket-horizontal', 'png'),
                              alt: "",
                              "css-class": "bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--horizontal"
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(defaultDrawData).ticketsToWin >= 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(WebpImage, {
                              src: _unref(bonImgUrl)('board/ticket-vertical', 'png'),
                              alt: "",
                              "css-class": "bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--vertical"
                            }, null, 8, ["src"]),
                            _createVNode(WebpImage, {
                              src: _unref(bonImgUrl)('board/ticket-horizontal', 'png'),
                              alt: "",
                              "css-class": "bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--horizontal"
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(WebpImage, {
                        class: "bonusomat-board-completed__no-ticket__image-wrapper",
                        "css-class": "bonusomat-board-completed__no-ticket__image",
                        src: _unref(bonImgUrl)('board/mr-green-bonusomat', 'png'),
                        alt: "Pan Zelený s Bonusomatem"
                      }, null, 8, ["src"]),
                      _createElementVNode("div", null, [
                        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "bonusomat-board-completed__no-ticket__title" }, " Nejdřív si ale vytočte všechny odměny Bonusomatu. ", -1)),
                        _createElementVNode("p", _hoisted_19, [
                          _createTextVNode(" Převzetím " + _toDisplayString(wordTiket2pad.value) + " se celá hra resetuje, převezměte si své odměny, abyste o ně nepřišel. ", 1),
                          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" Následně již nebude nic bránit tomu vás obdarovat " + _toDisplayString(wordTiket7pad.value) + " do Losovačky Bonusomatu. ", 1),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" Zasloužíte si " + _toDisplayString(wordHe4pad.value) + ". ", 1)
                        ])
                      ])
                    ]))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[7] || (_cache[7] = [
                _createStaticVNode("<div class=\"bonusomat-placeholder__skeleton bonusomat-board-completed__image-skeleton bonusomat-board-completed__no-ticket__image\"></div><div><div class=\"bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-title-skeleton\"></div><div class=\"bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton\"></div><div class=\"bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton\"></div><br><div class=\"bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton\"></div><div class=\"bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton\"></div></div>", 2)
              ]))),
          (isTicketClaimable.value && _unref(isPlayerDataLoaded))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(DsDivider, { theme: "dark" }),
                _createVNode(DsBottomSlotActionBar, {
                  "btn-submit-text": 'Převzít ' + wordTiket4pad.value,
                  "button-submit-icon": { iconRight: 'check' },
                  "has-btn-close": false,
                  theme: "dark",
                  onSubmitDialog: _unref(completeBoard)
                }, null, 8, ["btn-submit-text", "onSubmitDialog"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})